import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "app",
  initialState: {
    googleAccount: null,
    selected: {
      salesUnitId: null,
      customerId: null,
    },
    salesUnit: [],
    customers: [],
    contacts: [],
    employees: [],
    salesPersons: [],
    activityPurposes: [],
    opportunityStage: [],
    customerSetting: [],
    permissionLevel: null
  },
  reducers: {
    storeSalesUnit: (state, action) => {
      state.salesUnit = action.payload.data.getSalesUnit;
    },
    storeCustomers: (state, action) => {
      state.customers = action.payload;
    },
    storeContacts: (state, action) => {
      state.contacts = action.payload;
    },
    storeEmployees: (state, action) => {
      state.employees = action.payload;
    },
    storeSalesPersons: (state, action) => {
      state.salesPersons = action.payload;
    },
    storeActivityPurposes: (state, action) => {
      state.activityPurposes = action.payload;
    },
    storeOpportunityStage: (state, action) => {
      state.opportunityStage = action.payload;
    },
    storeCustomerSetting: (state, action) => {
      state.customerSetting = action.payload;
    },
    storeSelectedSalesUnit: (state, action) => {
      state.selected.salesUnitId = action.payload;
    },
    storeSelectedCustomer: (state, action) => {
      state.selected.customerId = action.payload;
    },
    storePermissionLevel: (state, action) => {
      state.permissionLevel = action.payload;
    },
    storeGoogleAcount: (state, action) => {
      state.googleAccount = action.payload;
    },
  },
});

export const {
  storeSalesUnit,
  storeCustomers,
  storeContacts,
  storeEmployees,
  storeSalesPersons,
  storeActivityPurposes,
  storeOpportunityStage,
  storeCustomerSetting,
  storeSelectedSalesUnit,
  storeSelectedCustomer,
  storePermissionLevel,
  storeGoogleAcount,
} = appSlice.actions;

export default appSlice.reducer;
